import Vue from "vue";

const state = [
	{
		id: 			"default", 
		assessment: 	"HhoSAanfneFrKeASrw8",
		name: 			"Alle Kontakte", 
		description:	"Diese Gruppe enthält alle Kontakte und wird automatisch verwaltet.", 
		members: 		["colleague1", "colleague2"], 
		notes: 			[
			{
				id: "not21", 
				created: "2020-09-30T11:03:00", 
				author: "colleague1", 
				content: "Eine Frage an die Kollegen?", 
				pinned: true
			},
			{
				id: "not411", 
				created: "2020-09-30T15:22:00", 
				author: "colleague2", 
				content: "Hier eine Antwort!", 
				pinned: false
			},
		],
		pinned: 		true
	},
	{	
		id: 			"DEf123aSFqwDfe214R", 
		assessment: 	"HhoSAanfneFrKeASrw8",
		name: 			"Klinische Leitung", 
		description: 	"Bereichsleitung, Chefärzte, Pflegeleitung", 
		members: 		["colleague3"], 
		pinned: 		false

    }
]


const actions = {
	// TODO - REPLACE WITH DB FUNCTION
	addMember( {state}, {group_id, user_id} ){
		var group = state.find( g => g.id == group_id );
		var index = state.indexOf( group );
		if( !group.members.find( u => u == user_id ) ){
			group.members.push( user_id )
		}
		Vue.set(state, index, group)
		return true;
	},
	// TODO - REPLACE WITH DB FUNCTION
	removeMember( {state}, {group_id, user_id} ){
		var group = state.find( g => g.id == group_id );
		var index = state.indexOf( group )
		group.members = group.members.filter( m => m !== user_id )
		Vue.set(state, index, group)
		return true;
	},
	// TODO - REPLACE WITH DB FUNCTION
	addNote( {state}, {group_id, note} ){
		var group = state.find( g => g.id == group_id );
		group.notes.push(note);
		return true;
	},
	// TODO - REPLACE WITH DB FUNCTION
	update( {state}, {group_id, update} ){
		var group = state.find( g => g.id == group_id );
		for( var key in update ){
			group[key] = update[key]
		}
		return true;
	},
	// TODO - REPLACE WITH DB FUNCTION
	add( {state}, group ){
		state.push(group)
		return true;
	},
	getOne(){

	}
} 

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
